import { GENERAL_LEDGER_PDF_MAX_ROWS } from "@common/constants/reports/general-ledger";

export const GENERAL_LEDGER_PDF_TOO_LARGE_TOOLTIP =
    "This report is too large for PDF. Narrow the date range or filters.";

interface PostingRowCountable {
    transactions: { transactions: { length: number } };
}

export function countGeneralLedgerPostingRows(
    accountsWithTransactions: PostingRowCountable[],
): number {
    return accountsWithTransactions.reduce(
        (total, wrapper) => total + wrapper.transactions.transactions.length,
        0,
    );
}

interface GeneralLedgerDownloadMenuStateParams {
    isFetching: boolean;
    isSuccess: boolean;
    postingRowCount: number;
}

export interface GeneralLedgerDownloadMenuState {
    menuDisabled: boolean;
    pdfDisabled: boolean;
}

// keepPreviousData: a refetch stays isSuccess with the previous row count
// while the download already uses the new filters. Disable the menu while
// isFetching so we never PDF the stale report; `!isSuccess` covers first load.
export function getGeneralLedgerDownloadMenuState({
    isFetching,
    isSuccess,
    postingRowCount,
}: GeneralLedgerDownloadMenuStateParams): GeneralLedgerDownloadMenuState {
    return {
        menuDisabled: isFetching || !isSuccess,
        pdfDisabled: postingRowCount > GENERAL_LEDGER_PDF_MAX_ROWS,
    };
}
